import { vMaska } from "maska/vue";

/**
 * Composable simples para facilitar o uso de máscaras em inputs
 */
export function useMask() {
  const masks = {
    PHONE: "['(##) # ####-####','(##) ####-####']",
    PHONE_9_DIGITS: "(##) # ####-####",
    PHONE_8_DIGITS: "(##) # ####-####",
    CNPJ: "**.***.***/****-##",
    CPF: "###.###.###-##",
    CEP: "#####-###",
    RG: "##.###.###-#",
    CNH: "###########",
    BOLETIM: "##.##.####",
    DATE: "##/##/####",
    TIME: "##:##",
    CURRENCY: "R$ #,##",
    PERCENTAGE: "##,##%",
    NUMBER: "##,##",
    INTEGER: "##",
    DECIMAL: "##,##",
    CREDIT_CARD: "#### #### #### ####",
    CREDIT_CARD_EXPIRATION: "##/##",
    CREDIT_CARD_CVV: "###",
    RemoveEspecial: "****************",
    ONE_DIGIT: "*",
    CONVENIO: "####################",
    TAXA_MASK_FORMAT: "9.99#,##",
    WHATSAPP: "['(##) # ####-####','(##) ####-####']",
    INTERNATIONAL_PHONE: "['+## (##) #####-####','+## (##) #####-####']"
  };

  const tokens = {
    TAXA_MASK_FORMAT: "9:[0-9]:repeated"
  };

  return {
    vMaska,
    masks,
    tokens
  };
}
